/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/2
 * @updateTime 2021/9/2
 * @decription 申请复议 =》 请求js
 * @namespace 【request】 请求
 */
import request from '@/api/axios';
export default {
    // 方法
    methods: {

        /**
         * 请求复议申请人数据
         * @param {Object} params 请求参数
         * @returns {Promise}
         * */
        requestFySqr(params) {
            return request({
                url: 'ssbq/api/fy/fysqrs',
                method: 'get',
                params:{
                    time: new Date().getTime(),
                    ...params
                },
            });
        },

        /**
         * 请求复议代理人数据
         * @param {Object} params 请求参数
         * @returns {Promise}
         * */
        requestFyDlr(params) {
            return request({
                url: 'ssbq/api/fy/fydlrs',
                method: 'get',
                params:{
                    time: new Date().getTime(),
                    ...params
                },
            });
        },

        /**
         * 请求复议上传材料数据
         * @param {Object} params 请求参数
         * @returns {Promise}
         * */
        requestFySCCL(params) {
            return request({
                url: 'ssbq/api/fy/fysccls',
                method: 'get',
                params:{
                    time: new Date().getTime(),
                    ...params
                },
            });
        }
    }
};
